import { FileSearch, FileText, Shield } from 'lucide-react';

const processes = [
  {
    icon: FileSearch,
    title: 'Comprehensive Search',
    description: 'We conduct a thorough trademark search to ensure your brand name is available and unique, minimizing the risk of rejection.',
  },
  {
    icon: FileText,
    title: 'Application Filing',
    description: 'Our experts prepare and file your trademark application with precision, ensuring all requirements are met for a smooth process.',
  },
  {
    icon: Shield,
    title: 'Registration Complete',
    description: 'Once approved, your trademark is officially registered and protected, giving you exclusive rights to your brand.',
  },
];

export const ProcessSteps = () => {
  return (
    <div className="section section-abstract-shapes bg-[#FFF5E6] relative" data-testid="process-steps">
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
            Our Simple Process
          </h2>
          <p className="text-lg text-[#2C1810] max-w-2xl mx-auto">
            Three easy steps to protect your brand and secure your trademark.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-[664px]:flex max-[664px]:gap-6 max-[664px]:overflow-x-auto max-[664px]:snap-x max-[664px]:scroll-smooth max-[664px]:px-8 max-[664px]:-mx-8 max-[664px]:pb-4">
          {processes.map((process, index) => {
            const Icon = process.icon;
            return (
              <div
                key={index}
                className="relative group max-[664px]:flex-shrink-0 max-[664px]:w-[280px] max-[664px]:snap-start"
                data-testid={`process-step-${index}`}
              >
                {/* Connecting line - hidden on mobile, shown on md+ except for last item */}
                {index < processes.length - 1 && (
                  <div className="hidden md:block absolute top-20 left-full w-full h-0.5 bg-gradient-to-r from-[#06214c] to-[#D4A574] opacity-30 z-0"></div>
                )}
                
                <div className="relative bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                  {/* Icon */}
                  <div className="flex justify-center mb-6">
                    <div className="w-20 h-20 bg-gradient-to-br from-[#06214c] to-[#D4A574] rounded-2xl flex items-center justify-center transform group-hover:rotate-6 transition-transform duration-300">
                      <Icon className="text-white" size={40} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-[#06214c] mb-4 text-center" style={{ fontFamily: 'Playfair Display' }}>
                    {process.title}
                  </h3>
                  <p className="text-gray-600 text-center leading-relaxed">
                    {process.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProcessSteps;
